import { installationDataClient } from './api-grpc';
import { InstallationDataTopic } from '../gen/proto/api/gateway/v1/installation_data_pb';
import type { JsonObject } from '@bufbuild/protobuf';

interface SewerEntry {
  data?: { value?: number };
}

export const installationDataApi = {
  async getLastPublicSewerLevel(installationUuid: string): Promise<number | null> {
    const response = await installationDataClient.getInstallationLatestDataTelemetry({
      installationUuid,
      topic: InstallationDataTopic.PUBLIC_SEWER_LEVEL,
    });
    const value = (response.data[0] as unknown as SewerEntry)?.data?.value ?? null;
    return value !== null ? Math.round(value * 100) / 100 : null;
  },

  async getLastPrivateSewerLevel(installationUuid: string): Promise<number | null> {
    const response = await installationDataClient.getInstallationLatestDataTelemetry({
      installationUuid,
      topic: InstallationDataTopic.PRIVATE_SEWER_LEVEL,
    });
    const value = (response.data[0] as unknown as SewerEntry)?.data?.value ?? null;
    return value !== null ? Math.round(value * 100) / 100 : null;
  },

  async getSewerLevelPage(
    installationUuid: string,
    cursor: string,
    pageSize: number,
  ): Promise<{ data: JsonObject[]; nextCursor: string; hasMore: boolean }> {
    const response = await installationDataClient.getInstallationDataTelemetryByCursor({
      installationUuid,
      topic: InstallationDataTopic.UNSPECIFIED,
      pageSize,
      cursor,
    });
    return {
      data: response.data,
      nextCursor: response.nextCursor,
      hasMore: response.hasMore,
    };
  },
};
